export default {
  GET(state, data) {
    state.user = { data }
  },
  LIST(state, data) {
    state.users = data
  },
  UPDATE(state, value) {
    state.user = {
      ...value,
      org_id: value.org_id ? value.org_id.id : null,
    }
  },
  FRESH(state) {
    state.user = {
      id: null,
      // group_permission: null,
      // last_login: null,
      // is_superuser: null,
      // first_name: null,
      // is_staff: null,
      // date_joined: null,
      // email: null,
      // role_id: null,
      org_id: null,
      // birth_date: null,
      // birth_place: null,
      // ctzn: null,
      // gd: null,
      // mid_name: null,
      // full_name: null,
      // mob_phone_no: null,
      // natn: null,
      // per_adr: null,
      // pport_expr_date: null,
      // pport_issue_date: null,
      // pport_issue_place: null,
      // pport_no: null,
      // sur_name: null,
      // tin: null,
      // user_type: null,
      // country: null,
      // valid: null,
      is_active: null,
      groups: null,
    }
  },
}
